 /*=========================================================================================
  File Name: mutations.js
  Description: App Mutations
  ----------------------------------------------------------------------------------------
  Item Name: App State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_EXCEPTION_STATE ( state, payload ) {
        state.exception.isCatched = true;
        state.exception.message = payload.message;
    },

    SET_REFRESH_STATE ( state, payload ) {
        state.exception.isCatched = false;
        state.exception.message = '';
    },


}